module.exports = __webpack_public_path__ + "img/hr-tree-07-h-leaves.93bfec7a.png";